const variants = {
  small: {
    maxWidth: `15%`,
    borderBottomWidth: `3px !important`,
    borderRadius: `50px !important`,
    display: `block`,
    borderColor: `primary.base`,
    opacity: 1,
    margin: `0 auto`,
  },
};

export const Divider = {
  variants,
};
